
export enum PlanDateSuggestionOption { 
 
  Today = "Today",
    Tomorrow = "Tomorrow",
  NextWorkingDay = "NextWorkingDay",
  PlanningBlockStartDate = "PlanningBlockStartDate", 

}